var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterBrand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 10.25V17.25C19 17.8023 18.5523 18.25 18 18.25H2C1.44772 18.25 1 17.8023 1 17.25V10.25H0V8.25L1 3.25H19L20 8.25V10.25H19ZM3 10.25V16.25H17V10.25H3ZM2.03961 8.25H17.9604L17.3604 5.25H2.63961L2.03961 8.25ZM4 11.25H12V14.25H4V11.25ZM1 0.25H19V2.25H1V0.25Z",
    fill: "#F5437E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterBrand);
export default __webpack_public_path__ + "static/media/footerBrand.7f34af9d979723cbbd3266de145fb278.svg";
export { ForwardRef as ReactComponent };